import React, { useMemo } from 'react';
import { useLocation } from '@reach/router';
import EventAside from './EventAside';
import AsideWithOwner from './AsideWithOwner';
import DefaultAside from './DefaultAside';
import { useLang } from 'utils/localisation';
import { asideDataDe, asideDataEn } from 'define/modalAside';

export default function ModalAside({ className, eventAsideData, asideData }) {
  const lang = useLang();
  const currentLink = useLocation().pathname;

  const asideDataWithOwner = lang === 'de' ? asideDataDe : asideDataEn;

  const ownerData = useMemo(
    () => asideDataWithOwner.find(item => currentLink.startsWith(item.url)),
    [currentLink, asideDataWithOwner],
  );

  if (eventAsideData) {
    return <EventAside className={className} data={eventAsideData} />;
  }

  if (ownerData) {
    return <AsideWithOwner className={className} ownerData={ownerData} />;
  }

  return <DefaultAside title={asideData?.title} className={className} />;
}
